import { useState } from "react";
import { workshopStats } from "../../game/data";
import type { PlayerState } from "../../game/playerState";
import type { WorkshopCategory } from "../../game/types";
import { LevelRow } from "./LevelRow";

const CATEGORIES: { id: WorkshopCategory; label: string }[] = [
  { id: "attack", label: "Attack" },
  { id: "defence", label: "Defence" },
  { id: "utility", label: "Utility" },
];

interface Props {
  state: PlayerState;
  update: (mutate: (draft: PlayerState) => void) => void;
}

export function WorkshopPanel({ state, update }: Props) {
  const [category, setCategory] = useState<WorkshopCategory>("attack");
  const stats = workshopStats.filter((s) => s.category === category);

  return (
    <div className="panel">
      <div className={`subtab-bar cat-${category}`}>
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            className={c.id === category ? "active" : ""}
            onClick={() => setCategory(c.id)}
          >
            {c.label}
          </button>
        ))}
      </div>
      <div className="rows">
        {stats.map((s) => (
          <LevelRow
            key={s.id}
            name={s.name}
            detail={s.description}
            level={state.workshop[s.id] ?? 0}
            maxLevel={s.maxLevel}
            onChange={(lvl) =>
              update((draft) => {
                draft.workshop[s.id] = lvl;
              })
            }
          />
        ))}
      </div>
    </div>
  );
}
